<template>
  <div class="dir-tree" :class="{active}">
    <div @click="active=!active">{{conf.title}}</div>
    <ul
      class="dir-list"
      :style="active ? 'height: auto;' : 'height: 0px;'"
    >
      <!--<CTree  v-for="(nextConf, index) in conf.child" :conf="nextConf" :treeConf="treeConf" :key="index"/>-->
      <div
        v-for="(item, index) in conf.child"
        :class="{chose: $route.query.articleId === item.id}"
        :key="`_${index}`"
        @click="$router.replace({name: $route.name, query: {...$route.query, articleId: item.id}})"
      >
        {{item.display}}
      </div>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'CTree',
    props: ['conf', 'treeConf'],
    data() {
      return {
        active: false,
      };
    },
    methods: {
    },
  };
</script>

<style lang="stylus" scoped>
  .dir-tree,
  .dir-list>div{
    padding: 5px 0 5px 20px;
    line-height: 30px;
    color: #333;
    cursor: pointer;
  }
  .dir-tree>div{
    position: relative;
    padding-left: 5px;
  }
  .dir-tree>div:hover{
    background-color: #e0e4e8;
  }
  .dir-tree>ul>div.chose{
    background-color: #e0e4e8;
  }
  .dir-tree>div:before{
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(-90deg);
    left: -14px;
    content: "";
    display: block;
    border-top: 5px solid #333;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    transition: all .3s;
  }
  .dir-tree.active>div:before{
    transform: translateY(-50%) rotate(0deg);
  }
  .dir-tree > ul{
    opacity: 0;
    transition: all .3s;
    overflow: hidden;
  }
  .dir-tree.active > ul{
    opacity: 1;
  }
</style>
